import { Injectable } from '@angular/core';
import { HttpEvent, HttpHandler, HttpInterceptor, HttpRequest } from '@angular/common/http';
import { catchError, Observable, throwError } from 'rxjs';
import { AuthService } from '../../auth/services/auth.service';
import { environment } from '../../../environments/environment';
import { PASS_RAW_ERROR } from './http-error.context';

@Injectable()
export class JwtInterceptor implements HttpInterceptor {

  constructor(private authService: AuthService) {
  }

  intercept(request: HttpRequest<any>, next: HttpHandler): Observable<HttpEvent<any>> {
    const isLoggedIn = this.authService.isLoggedIn();
    const isApiUrl = request.url.startsWith(environment.api);

    if (isLoggedIn && isApiUrl) {
      request = request.clone({
        setHeaders: { Authorization: `Bearer ${this.authService.getGwtToken()}` }
      });
    }

    return next.handle(request)
      .pipe(
        catchError(err => {
          if (err.status === 401) {
            // auto logout if 401 response returned from api
            this.authService.logout();

            if (!request.url.match(/auth\/login/)) {
              location.reload();
            }
          }

          console.error(err);

          if (request.context.get(PASS_RAW_ERROR)) {
            return throwError(() => err);
          }

          const error = err.error?.message || err.statusText;
          return throwError(() => error);
        }));
  }
}
